import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { ShieldCheck } from "lucide-react";
import { finPost, useAsk, money } from "@/components/accounts/shared";
import { Button } from "@/components/ui/button";

export function PendingApprovals() {
  const qc = useQueryClient();
  const [ask, askNode] = useAsk();
  const { data } = useQuery({ queryKey: ["approvals-inbox"], refetchInterval: 60000, queryFn: async () => (await api.get("/approvals/inbox")).data });
  if (!data?.items?.length) return null;
  const decide = async (it, ok) => {
    const r = ok ? "" : await ask("Reason", "Tell the requester why this is being rejected or sent back.");
    if (!ok && !r) return;
    if (await finPost(ask, ok ? it.approve : it.reject, { reason: r || "" }, ok ? "Approved" : "Rejected")) {
      qc.invalidateQueries({ queryKey: ["approvals-inbox"] });
    }
  };
  return (
    <section className="mb-6 rounded-2xl border border-amber-200 bg-amber-50/50 p-4" data-testid="pending-approvals">
      <p className="mb-3 flex items-center gap-2 font-display font-bold text-slate-900"><ShieldCheck className="h-4 w-4 text-amber-600" /> Waiting for your approval
        <span className="rounded-full bg-amber-600 px-2 text-xs text-white" data-testid="pending-approvals-count">{data.total}</span></p>
      <ul className="divide-y divide-amber-100 text-sm">{data.items.slice(0, 8).map((it) => (
        <li key={it.id} className="flex flex-wrap items-center justify-between gap-2 py-2" data-testid={`pa-${it.id}`}>
          <div className="min-w-0">
            <p><span className="font-semibold">{it.type}</span> <span className="text-slate-600">{it.ref}</span></p>
            <p className="text-xs text-slate-500">{it.requester ? `From ${it.requester} \u00b7 ` : ""}{String(it.submitted_at).slice(0, 10) || "date unknown"} · pending · {it.action}</p>
          </div>
          <div className="flex items-center gap-2">
            {it.amount != null && <b>{money(it.amount)}</b>}
            <Link to={it.review} className="text-xs text-sky-700 underline" data-testid={`pa-review-${it.id}`}>Review</Link>
            {it.approve && <Button size="sm" className="h-7 bg-emerald-700 px-2 text-xs text-white" onClick={() => decide(it, true)} data-testid={`pa-approve-${it.id}`}>Approve</Button>}
            {it.reject && <Button size="sm" variant="outline" className="h-7 px-2 text-xs text-rose-700" onClick={() => decide(it, false)} data-testid={`pa-reject-${it.id}`}>Reject</Button>}
          </div>
        </li>))}
        {data.total > 8 && <li className="pt-2 text-xs text-slate-500">+{data.total - 8} more in their screens</li>}
      </ul>
      {askNode}
    </section>
  );
}
